/**
 * dom元素拖动
 * 在元素上绑定v-drag指令，即可拖动
 */
export default {
  directives: {
    drag: { // 拖拽指令
      inserted($el, binding, vnode) {
        function elDown(ev) {
          ev = ev.touches && ev.touches[0] || ev;
          $el.setAttribute('data-flag', false)
          // 用元素距离视窗的X、Y坐标，减去el元素最近的相对定位父元素的left、top值
          let sX = ev.clientX - $el.offsetLeft;
          let sY = ev.clientY - $el.offsetTop;
          const firstTime = new Date().getTime();
          window.addEventListener('mousemove', rootMove, { passive: false });
          window.addEventListener('touchmove', rootMove, { passive: false });
          window.addEventListener('mouseup', rootUp, { passive: false });
          window.addEventListener('touchend', rootUp, { passive: false });
          function rootMove(ev) {
            ev.preventDefault();
            ev.stopPropagation();
            ev = ev.touches && ev.touches[0] || ev;
            $el.style.left = ev.clientX - sX + 'px';
            $el.style.top = ev.clientY - sY + 'px';
            if (window.$isMobile) {
              $el.style.left = vnode.context.pxToRem(ev.clientX - sX);
              $el.style.top = vnode.context.pxToRem(ev.clientY - sY);
            } else {
              $el.style.left = ev.clientX - sX + 'px';
              $el.style.top = ev.clientY - sY + 'px';
            }
          }
          function rootUp() {
            window.removeEventListener('mousemove', rootMove, { passive: false });
            window.removeEventListener('touchmove', rootMove, { passive: false });
            window.removeEventListener('mouseup', rootUp, { passive: false });
            window.removeEventListener('touchend', rootUp, { passive: false });
            const lastTime = new Date().getTime();
            if (lastTime - firstTime < 200) {
              $el.setAttribute('data-flag', true)
            }
          }
        }
        $el.onmousedown = elDown;
        $el.ontouchstart = elDown;
      },
      unbind($el) {
        $el.onmousedown = null;
        $el.ontouchstart = null;
      }
    }
  }
};